import React, { useState, useEffect, Fragment, useRef } from "react";
import { setup } from "goober";
import "../MultiStep/MultiStep.scss";
import { withTranslation } from "react-i18next";
import CancelContractModal from "../CancelContractModal";
import StepOne from "../MultiStep/StepOne";
import StepTwo from "../MultiStep/StepTwo";
import StepThree from "../MultiStep/StepThree";
import StepFour from "../MultiStep/StepFour";
import StepFive from "../MultiStep/StepFive";
import StepSix from "../MultiStep/StepSix";
import * as moment from "moment";
import { useHistory } from "react-router-dom";
import { cloneDeep } from "lodash";
import { stripHtml } from "utils/sanitize";
import {
  useContractTemplateById,
  useEditContractMutation,
  getContractTemplatePdf,
  useContractTemplateMutation,
} from "repositories/contract-repository";
import toast from "react-hot-toast";
import constants from "../../../../../constants";
import PreviewPersonnelContract from "../PreviewPersonnelContract";
import PreviewAssociateContract from "../PreviewAssociateContract";
import Loader from "components/Loader";
import ConfirmContractModal from "../ConfirmContractModal";
import SaveTemplateModal from "../SaveTemplateModal";
import {
  b64toBlob,
  encodeId,
  getCacheLocalstorage,
  isMobileTab,
  normalizeContractDetailsDatesForApi,
  parseCalendarDateToLocalDate,
} from "utils";
import FileSaver from "file-saver";
import {
  addDataIntoContractArray,
  maxLimitReach,
  replaceableValue,
  replaceAll,
} from "../AddContract";
import { useQueryClient } from "react-query";

setup(React.createElement);
const getStep = (defaultIndex, newIndex, length) => {
  if (newIndex <= length) {
    return newIndex;
  }
  return defaultIndex;
};
export const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
};

const getTopNavStyles = (indx, length) => {
  const styles = [];
  for (let i = 0; i < length; i++) {
    if (i < indx) {
      styles.push("done");
    } else if (i === indx) {
      styles.push("doing");
    } else {
      styles.push("todo");
    }
  }
  return styles;
};

const getButtonsState = (indx, length) => {
  if (indx > 0 && indx < length - 1) {
    return {
      showPreviousBtn: true,
      showNextBtn: true,
      showCompleteBtn: false,
    };
  } else if (indx === 0) {
    return {
      showPreviousBtn: false,
      showNextBtn: true,
      showCompleteBtn: false,
    };
  } else {
    return {
      showPreviousBtn: true,
      showNextBtn: false,
      showCompleteBtn: true,
    };
  }
};

function EditContract({
  officeId,
  staffId,
  contractId,
  officeDetail,
  t,
  ...props
}) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [confirmSentModal, setConfirmSentModal] = useState(false);
  const [designationType, setDesignationType] = useState(2);
  const [pdfLoader, setPdfLoader] = useState(false);
  const [saveContractTemplateModal, setSaveContractTemplateModal] =
    useState(false);

  const [steps, setSteps] = useState([1, 2, 3, 4, 5, 6]);
  const [fieldList, setfieldList] = useState([]);
  const [previewContract, setPreviewContract] = useState(false);
  const [showPrompt, setShowPrompt] = useState(true);

  const stateRef = useRef();
  const history = useHistory();

  const [BasicDetails, setBasicDetails] = useState(() => {
    const values = getCacheLocalstorage(
      constants.contracts.contractslocalstorageKey,
      true,
    );
    return {
      contractId,
      IsSubmitted: false,
      Type: 2,
      Date: moment().toDate(),
      BusinessLegalName: officeDetail ? officeDetail.name : "",
      Position: "",
      OfficeAddress: officeDetail ? officeDetail?.address : "",
      LengthOfEmployment: "",
      StartOfWorkDate: moment().toDate(),
      EndOfWorkDate: moment().add(1, "d").toDate(),
      EmployeeName: values.staffName || "",
      EmployeeAddress: values?.address || "",
      Salary: "",
      ContractDetails: [],
      commission: "",
      bonus: "",
    };
  });
  stateRef.current = BasicDetails;

  const [isSavedTemplate, setisSavedTemplate] = useState("false");
  const {
    isLoading: isLoadingTemplate,
    data: contractTemplateData,
    error: contractTemplateError,
  } = useContractTemplateById(contractId, { cacheTime: 0 });
  if (!isLoadingTemplate && !contractTemplateData && contractTemplateError) {
    toast.error(contractTemplateError.message, {
      id: "error",
    });
    history.push(
      constants.routes.accountOwner.staffContracts
        .replace(":officeId", encodeId(officeId))
        .replace(":staffId", encodeId(staffId)),
    );
  }
  const queryClient = useQueryClient();

  useEffect(() => {
    return () => {
      queryClient.invalidateQueries(["/Contract/ContractId", contractId]);
    };
  }, []);
  if (
    !isLoadingTemplate &&
    contractTemplateData &&
    BasicDetails.ContractDetails.length === 0
  ) {
    let tempData = { ...BasicDetails };
    tempData["Date"] = parseCalendarDateToLocalDate(contractTemplateData.date);
    tempData["BusinessLegalName"] = contractTemplateData.businessLegalName;
    tempData["Position"] = contractTemplateData.position;
    tempData["OfficeAddress"] = contractTemplateData.officeAddress;
    tempData["LengthOfEmployment"] = contractTemplateData.lengthOfEmployment;
    tempData["StartOfWorkDate"] = parseCalendarDateToLocalDate(
      contractTemplateData.startOfWorkDate,
    );
    tempData["EndOfWorkDate"] = contractTemplateData?.endOfWorkDate
      ? parseCalendarDateToLocalDate(contractTemplateData?.endOfWorkDate)
      : null;
    tempData["EmployeeName"] = contractTemplateData.employeeName;
    tempData["EmployeeAddress"] = contractTemplateData.employeeAddress;
    tempData["Salary"] = contractTemplateData.salary;
    tempData["commission"] = contractTemplateData?.commission || "";
    tempData["bonus"] = contractTemplateData?.bonus || "";
    tempData["IsSubmitted"] = contractTemplateData?.status !== 1;
    tempData["ContractDetails"] = contractTemplateData.contractDetails.map(
      (e) => {
        if (
          e.title === "Authorised Signature" &&
          !!e.text &&
          e.text.split(
            `${constants.containerName.CONTAINER_NAME_CONTRACTS_SIGNATURE}/`,
          )[1]
        ) {
          e.text =
            `${constants.containerName.CONTAINER_NAME_CONTRACTS_SIGNATURE}/` +
            e.text.split(
              `${constants.containerName.CONTAINER_NAME_CONTRACTS_SIGNATURE}/`,
            )[1];
        }
        return e;
      },
    );
    if (
      contractTemplateData.contractDetails[0] &&
      contractTemplateData.contractDetails[0].templateType
    ) {
      setDesignationType(contractTemplateData.contractDetails[0].templateType);
      localStorage.setItem(
        "designation",
        contractTemplateData.contractDetails[0].templateType,
      );
      let stepArray =
        contractTemplateData.contractDetails[0].templateType === 1
          ? [1, 2, 3, 4]
          : [1, 2, 3, 4, 5, 6];
      setSteps(stepArray);
    }
    setBasicDetails(tempData);
  }

  const showNav =
    typeof props.showNavigation === "undefined" ? true : props.showNavigation;

  const [activeStep] = useState(getStep(0, props.activeStep, steps.length));
  const [stylesState, setStyles] = useState(
    getTopNavStyles(activeStep, steps.length),
  );
  const [compState, setComp] = useState(activeStep);
  const [buttonsState, setButtons] = useState(
    getButtonsState(activeStep, steps.length),
  );
  const editContractMutation = useEditContractMutation();
  const contractTemplateMutation = useContractTemplateMutation();

  const [errors, seterrors] = useState({});

  const [contractFormDisplayData, setDisplayData] = useState([]);
  useEffect(() => {
    getContractList();
    addDataIntoContractArray({
      BasicDetails,
      officeDetail,
      setDisplayData,
    });
    if (contractTemplateData && contractTemplateData.status !== 2) {
      if (showPrompt) {
        history.block(() => {
          setModalIsOpen(true);
          return false;
        });
      } else {
        history.block(() => {});
      }
    }

    return () => {
      history.block(() => {});
    };
    // eslint-disable-next-line
  }, [BasicDetails, history, showPrompt]);

  const setStepState = (indx) => {
    setStyles(getTopNavStyles(indx, steps.length));
    setComp(indx < steps.length ? indx : compState);
    setButtons(getButtonsState(indx, steps.length));
  };

  const scrollToError = () => {
    setTimeout(() => {
      const error = document.getElementsByClassName("error-msg");
      if (error && error.length) {
        error[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "start",
        });
      }
    }, 1000);
  };
  const incereaseStateAndScrollToZero = () => {
    setStepState(compState + 1);
    window.scrollTo(0, 0);
  };

  const next = (saveAsDrafCheck) => {
    const checkSaveAsDraft = saveAsDrafCheck === true;
    if (compState === 0) {
      if (isValidStepOne()) {
        if (!checkSaveAsDraft) {
          incereaseStateAndScrollToZero();
        }
        return true;
      } else {
        scrollToError();
      }
    } else if (compState === 1) {
      if (isValidStep(2)) {
        if (!checkSaveAsDraft) {
          incereaseStateAndScrollToZero();
        }
        return true;
      } else {
        scrollToError();
      }
    } else if (compState === 2) {
      if (isValidStep(3)) {
        if (!checkSaveAsDraft) {
          incereaseStateAndScrollToZero();
        }
        return true;
      } else {
        scrollToError();
      }
    } else if (compState === 3) {
      if (isValidStep(4)) {
        if (!checkSaveAsDraft) {
          incereaseStateAndScrollToZero();
          if (designationType === 1) {
            setPreviewContract(true);
          }
        }
        return true;
      } else {
        scrollToError();
      }
    } else if (compState === 4) {
      if (isValidStep(5)) {
        if (!checkSaveAsDraft) {
          incereaseStateAndScrollToZero();
        }
        return true;
      } else {
        scrollToError();
      }
    } else if (compState === 5) {
      if (isValidStep(6)) {
        if (!checkSaveAsDraft) {
          incereaseStateAndScrollToZero();
          setPreviewContract(true);
        }
        return true;
      } else {
        scrollToError();
      }
    } else {
      if (!checkSaveAsDraft) {
        setStepState(compState + 1);
      }
      return true;
    }
  };
  const previous = () => {
    if (previewContract) {
      setPreviewContract(false);
    } else {
      setStepState(compState > 0 ? compState - 1 : compState);
    }
  };

  const renderSteps = () =>
    steps.map((s, i) => {
      if (stylesState[i] === "todo") {
        return (
          <li className={"todo-list "} key={i} value={i}>
            <span>{i + 1}</span>
          </li>
        );
      } else if (stylesState[i] === "doing") {
        return (
          <li className={"doing-list "} key={i} value={i}>
            <span>{i + 1}</span>
          </li>
        );
      } else {
        return (
          <li className={"done-list "} key={i} value={i}>
            <span>{i + 1}</span>
          </li>
        );
      }
    });

  const isValidStep = (step) => {
    const newArr = cloneDeep(stateRef.current.ContractDetails);
    const isValid = !newArr
      .filter((e) => e.isActive && e.stepNumber === step)
      .some((e) => {
        if (e.isHtmlContent) {
          if (!removeHtmlChar(e.text)) {
            e.error = t("form.errors.emptyField", { field: e.title });
            return true;
          } else if (removeHtmlChar(e.text).length > maxLimitReach) {
            e.error = t("form.errors.maxLimit", {
              limit: maxLimitReach.toString(),
            });
            return true;
          } else {
            return false;
          }
        } else {
          if (e.text == "" || e.text == null) {
            if (e.title == "Authorised Signature") {
              e.error = t("form.errors.imageUpload");
            } else {
              e.error = t("form.errors.emptyField", { field: e.title });
            }
          }
        }
        return e.text == "" || e.text == null;
      });

    setBasicDetails((prevState) => ({ ...prevState, ContractDetails: newArr }));
    return isValid;
  };

  const isValidStepOne = () => {
    let isValid = true;
    const errorsCopy = cloneDeep(errors);
    let BasicDetailsCopy = stateRef.current;
    isValid = isValidStep(1);
    if (!BasicDetailsCopy.Date) {
      errorsCopy.Date = t("form.errors.emptyField", {
        field: t("contracts.dateContract"),
      });
      isValid = false;
    } else if (
      !moment(BasicDetailsCopy.Date).isSameOrAfter(moment(new Date()), "day")
    ) {
      errorsCopy.Date = t("form.errors.pastDate");
      isValid = false;
    } else {
      delete errorsCopy["Date"];
    }

    if (!BasicDetailsCopy.BusinessLegalName?.trim()) {
      errorsCopy.BusinessLegalName = t("form.errors.emptyField", {
        field: t("contracts.businessLegalName"),
      });
      isValid = false;
    } else if (
      BasicDetailsCopy.BusinessLegalName &&
      BasicDetailsCopy.BusinessLegalName?.trim()?.length > 80
    ) {
      errorsCopy.BusinessLegalName = t("form.errors.maxLimit", { limit: "80" });
      isValid = false;
    } else {
      delete errorsCopy["BusinessLegalName"];
    }

    if (!BasicDetailsCopy.Position?.trim()) {
      errorsCopy.Position = t("form.errors.emptyField", {
        field: t("contracts.position"),
      });
      isValid = false;
    } else if (
      BasicDetailsCopy.Position &&
      BasicDetailsCopy.Position?.trim()?.length > 100
    ) {
      errorsCopy.Position = t("form.errors.maxLimit", { limit: "100" });
      isValid = false;
    } else {
      delete errorsCopy["Position"];
    }

    if (!BasicDetailsCopy.OfficeAddress?.trim()) {
      errorsCopy.OfficeAddress = t("form.errors.emptyField", {
        field: t("form.fields.officeAddress"),
      });
      isValid = false;
    } else if (BasicDetailsCopy.OfficeAddress?.trim()?.length > 200) {
      errorsCopy.OfficeAddress = t("form.errors.maxLimit", { limit: "200" });
      isValid = false;
    } else {
      delete errorsCopy["OfficeAddress"];
    }

    if (!BasicDetailsCopy.LengthOfEmployment?.trim()) {
      errorsCopy.LengthOfEmployment = t("form.errors.emptyField", {
        field: t("contracts.lengthEmployment"),
      });
      isValid = false;
    } else if (BasicDetailsCopy.LengthOfEmployment?.trim()?.length > 36) {
      errorsCopy.LengthOfEmployment = t("form.errors.maxLimit", {
        limit: "36",
      });
      isValid = false;
    } else {
      delete errorsCopy["LengthOfEmployment"];
    }

    if (!BasicDetailsCopy.StartOfWorkDate) {
      errorsCopy.StartOfWorkDate = t("form.errors.emptyField", {
        field: t("contracts.startWork"),
      });
      isValid = false;
    } else {
      delete errorsCopy["StartOfWorkDate"];
    }

    if (
      BasicDetailsCopy.EndOfWorkDate &&
      moment(BasicDetailsCopy.EndOfWorkDate).isBefore(
        moment(BasicDetailsCopy.StartOfWorkDate),
      )
    ) {
      errorsCopy.EndOfWorkDate = t("form.errors.endDate");
      isValid = false;
    } else {
      delete errorsCopy["EndOfWorkDate"];
    }

    if (!BasicDetailsCopy.EmployeeName?.trim()) {
      errorsCopy.EmployeeName = t("form.errors.emptyField", {
        field: t("contracts.employeeName"),
      });
      isValid = false;
    } else if (BasicDetailsCopy.EmployeeName?.trim()?.length > 50) {
      errorsCopy.EmployeeName = t("form.errors.maxLimit", { limit: "50" });
      isValid = false;
    } else {
      delete errorsCopy["EmployeeName"];
    }

    if (!BasicDetailsCopy.EmployeeAddress?.trim()) {
      errorsCopy.EmployeeAddress = t("form.errors.emptyField", {
        field: t("contracts.employeeAddress"),
      });
      isValid = false;
    } else if (BasicDetailsCopy.EmployeeAddress?.trim()?.length > 200) {
      errorsCopy.EmployeeAddress = t("form.errors.maxLimit", { limit: "200" });
      isValid = false;
    } else {
      delete errorsCopy["EmployeeAddress"];
    }

    if (!BasicDetailsCopy.Salary?.trim()) {
      errorsCopy.Salary = t("form.errors.emptyField", {
        field: t("contracts.salaryFeeWage"),
      });
      isValid = false;
    } else if (BasicDetailsCopy.Salary?.trim()?.length > 100) {
      errorsCopy.Salary = t("form.errors.maxLimit", { limit: "100" });
      isValid = false;
    } else {
      delete errorsCopy["Salary"];
    }
    if (BasicDetailsCopy?.commission?.trim()?.length > 300) {
      errorsCopy.commission = t("form.errors.maxLimit", { limit: "300" });
      isValid = false;
    } else {
      delete errorsCopy["commission"];
    }
    if (BasicDetailsCopy?.bonus?.trim()?.length > 300) {
      errorsCopy.bonus = t("form.errors.maxLimit", { limit: "300" });
      isValid = false;
    } else {
      delete errorsCopy["bonus"];
    }

    seterrors(errorsCopy);
    return isValid;
  };

  const renderForm = (step) => {
    switch (step) {
      case 0:
        return (
          <StepOne
            contractFormDisplayData={contractFormDisplayData}
            contractData={BasicDetails}
            setBasicDetails={setBasicDetails}
            errors={errors}
            hideRadio={true}
            setFormDetails={setFormDetails}
            setisSavedTemplate={setisSavedTemplate}
            handleSwitch={handleSwitch}
            savedTemplate={isSavedTemplate}
          />
        );
      case 1:
        return (
          <StepTwo
            contractFormDisplayData={contractFormDisplayData}
            contractData={BasicDetails}
            setBasicDetails={(e) => {
              setBasicDetails(e);
            }}
            setFormDetails={setFormDetails}
            handleSwitch={handleSwitch}
          />
        );
      case 2:
        return (
          <StepThree
            contractFormDisplayData={contractFormDisplayData}
            contractData={BasicDetails}
            setBasicDetails={(e) => {
              setBasicDetails(e);
            }}
            setFormDetails={setFormDetails}
            handleSwitch={handleSwitch}
          />
        );
      case 3:
        return (
          <StepFour
            contractFormDisplayData={contractFormDisplayData}
            contractData={BasicDetails}
            setBasicDetails={(e) => {
              setBasicDetails(e);
            }}
            fieldList={fieldList}
            setFormDetails={setFormDetails}
            handleSwitch={handleSwitch}
          />
        );
      case 4:
        return (
          <StepFive
            contractFormDisplayData={contractFormDisplayData}
            contractData={BasicDetails}
            setBasicDetails={(e) => {
              setBasicDetails(e);
            }}
            setFormDetails={setFormDetails}
            handleSwitch={handleSwitch}
          />
        );
      case 5:
        return (
          <StepSix
            contractFormDisplayData={contractFormDisplayData}
            contractData={BasicDetails}
            setBasicDetails={(e) => {
              setBasicDetails(e);
            }}
            fieldList={fieldList}
            setFormDetails={setFormDetails}
            handleSwitch={handleSwitch}
          />
        );
      default:
      // do nothing
    }
  };
  const renderNav = (show) =>
    show && (
      <>
        <div>
          <button
            className="button button-round button-border button-dark"
            style={
              buttonsState.showPreviousBtn
                ? props.prevStyle
                : { display: "none" }
            }
            onClick={previous}
          >
            {t("contracts.previousStep")}
          </button>
        </div>

        <div className="next-step-col">
          <span className="d-flex align-items-center cancel-btn-box">
            <div
              className="link-btn cancel-btn"
              onClick={() => {
                if (contractTemplateData && contractTemplateData.status !== 2) {
                  setModalIsOpen(true);
                } else {
                  exitForm();
                }
              }}
            >
              {t("cancel")}
            </div>
          </span>
          <button
            className="button button-round button-shadow mr-4"
            style={previewContract ? props.completeStyle : { display: "none" }}
            onClick={() => {
              exportContract();
            }}
          >
            {t("contracts.exportEmploymentContract")}
          </button>
          <button
            className="button button-round button-shadow"
            style={
              !previewContract && buttonsState.showNextBtn
                ? props.nextStyle
                : { display: "none" }
            }
            onClick={next}
          >
            {t("contracts.nextStep")}
          </button>
          <button
            className="button button-round button-shadow"
            style={
              !previewContract && buttonsState.showCompleteBtn
                ? props.completeStyle
                : { display: "none" }
            }
            onClick={next}
          >
            {t("contracts.reviewEmploymentContract")}
          </button>

          <button
            className="button button-round button-shadow send-emp-btn"
            style={previewContract ? props.completeStyle : { display: "none" }}
            onClick={() => {
              setConfirmSentModal(true);
            }}
          >
            {t("contracts.sendEmploymentContract")}
          </button>
        </div>
      </>
    );
  const saveDraftContract = async (submit) => {
    setConfirmSentModal(false);
    setPdfLoader(true);
    try {
      let formData = { ...BasicDetails };
      formData.IsSubmitted = !submit;
      ["Date", "StartOfWorkDate", "EndOfWorkDate"].forEach((key) => {
        if (formData[key]) {
          formData[key] = moment(formData[key]).format("YYYY-MM-DD");
        }
      });
      formData.ContractDetails = normalizeContractDetailsDatesForApi(
        formData.ContractDetails,
      );
      Object.keys(formData).forEach((key) => {
        if (typeof formData[key] === "string") {
          formData[key] = formData[key]?.trim();
        }
      });
      await editContractMutation.mutateAsync(formData);
      setModalIsOpen(false);
      toast.success(t("contracts.contractUploadedSuccessfully"));
      setShowPrompt(false);
      if (submit) {
        exitForm();
      } else {
        setSaveContractTemplateModal(true);
      }
    } catch (e) {
      toast.error(e.message);
      setModalIsOpen(false);
    } finally {
      setPdfLoader(false);
    }
  };
  const sendContract = async () => {
    setBasicDetails({ ...BasicDetails, IsSubmitted: true });
    saveDraftContract(false);
  };

  const getContractList = () => {
    let fields = [];
    const contractDetailsList =
      BasicDetails.ContractDetails || contractTemplateData.contractDetails;
    if (contractDetailsList?.length) {
      if (designationType === 1) {
        contractDetailsList.forEach((e, key) => {
          if (e.isMainSection) {
            fields.push(e);
          }
        });
        setfieldList(fields);
      } else {
        let contractData = [...contractDetailsList];
        contractData.reverse();
        const lastElemStepOne = contractData.find(
          (x) => x.stepNumber === 1 && x.isMainSection,
        );
        const lastElemStepTwo = contractData.find((x) => x.stepNumber === 2);
        const lastElemStepThree = contractData.find((x) => x.stepNumber === 5);
        const lastElemStepFour = contractData.find(
          (x) => x.stepNumber === 6 && x.isHtmlContent,
        );
        if (lastElemStepOne)
          lastElemStepOne.title = t("contracts.ownerAndTheAssociateAgree");
        if (lastElemStepTwo)
          lastElemStepTwo.title = t("contracts.theOwnerAgree");
        if (lastElemStepThree)
          lastElemStepThree.title = t("contracts.theAssociateAgree");
        if (lastElemStepFour) lastElemStepFour.title = t("contracts.general");
        setfieldList([
          lastElemStepOne,
          lastElemStepTwo,
          lastElemStepThree,
          lastElemStepFour,
        ]);
      }
    }
  };

  const exitForm = () => {
    setShowPrompt(false);
    setTimeout(() => {
      history.push(
        constants.routes.accountOwner.staffContracts
          .replace(":officeId", encodeId(officeId))
          .replace(":staffId", encodeId(staffId)),
      );
    }, 30);
  };

  const removeHtmlChar = (html) => {
    return stripHtml(html);
  };

  let timeout = null;

  const setFormDetails = (index, value, debounce = false) => {
    let newArr = cloneDeep(stateRef.current.ContractDetails);
    let item = cloneDeep(newArr[index]);
    if (item) {
      if (value instanceof Date) {
        value = moment(value).format("DD-MM-YYYY");
      }
      const htmlChar = removeHtmlChar(value);

      if (
        htmlChar?.length == 0 ||
        htmlChar.length > maxLimitReach
      ) {
        if (
          htmlChar.length > maxLimitReach &&
          item.isHtmlContent
        ) {
          item.error = t("form.errors.maxLimit", {
            limit: maxLimitReach.toString(),
          });
        } else if (htmlChar?.length == 0&&item.title!=="Date") {
          item.error = t("form.errors.emptyField", { field: item.title });
        }
      } else {
        delete item["error"];
      }
      if (typeof item.text === "string") {
        const matches =
          item.text.match(/\[(.*?)\]/g)?.map((m) => m.slice(1, -1)) || [];
        if (matches.length) {
          matches.forEach((res) => {
            const findKey = replaceableValue.find(
              (resp) => resp.text === `[${res}]`,
            );
            if (findKey?.key) {
              const valueInObject = stateRef.current[findKey.key];
              if (valueInObject) {
                let markwillbeplaceHolder;
                if (stateRef.current[findKey.key] instanceof Date) {
                  markwillbeplaceHolder = moment(
                    stateRef.current[findKey.key],
                  ).format("DD-MM-YYYY");
                } else {
                  markwillbeplaceHolder = stateRef.current[findKey.key]?.trim();
                }
                value = replaceAll(value, markwillbeplaceHolder, `[${res}]`);
              }
            }
          });
        }
      }
      item.text = value;
      newArr[index] = item;
      stateRef.current = { ...stateRef.current, ContractDetails: newArr };
      if (debounce) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          setBasicDetails({ ...stateRef.current, ContractDetails: newArr });
        }, 2000);
      } else {
        setBasicDetails({ ...stateRef.current, ContractDetails: newArr });
      }
    }
  };

  const handleSwitch = (index, status) => {
    let newArr = [...stateRef.current.ContractDetails];
    if (newArr[index]) {
      newArr[index].isActive = status;
      newArr[index].text = newArr[index].text.substring(0, 995);
      delete newArr[index]["error"];
      setBasicDetails({ ...stateRef.current, ContractDetails: newArr });
      getContractList();
    }
  };

  const exportContract = async () => {
    setPdfLoader(true);
    try {
      let formData = { ...BasicDetails };
      delete formData["staffId"];
      ["Date", "StartOfWorkDate", "EndOfWorkDate"].forEach((key) => {
        if (formData[key]) {
          formData[key] = moment(formData[key]).format("YYYY-MM-DD");
        }
      });
      formData.ContractDetails = normalizeContractDetailsDatesForApi(
        formData.ContractDetails,
      );
      Object.keys(formData).forEach((key) => {
        if (typeof formData[key] === "string") {
          formData[key] = formData[key]?.trim();
        }
      });
      formData["contractId"] = contractId;
      await editContractMutation.mutateAsync(formData);
      const resp = await getContractTemplatePdf(contractId);
      if (resp) {
        const blob = b64toBlob(resp, "application/pdf");
        if (isMobileTab()) {
          FileSaver.saveAs(blob);
        } else {
          const blobUrl = URL.createObjectURL(blob);
          const pdfWindow = window.open("");
          pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='" +
              blobUrl +
              "'></iframe>",
          );
          pdfWindow.document.close();
        }
      }
      setPdfLoader(false);
    } catch (e) {
      setPdfLoader(false);
    }
  };

  const saveContractTemplate = async (Name) => {
    setPdfLoader(true);
    try {
      const values = getCacheLocalstorage(
        constants.contracts.contractslocalstorageKey,
        true,
      );
      const formData = {
        contractId,
        officeId,
        TemplateType: +designationType,
        OwnerId: values?.ownerId,
        Name,
      };
      await contractTemplateMutation.mutateAsync(formData);
      setSaveContractTemplateModal(false);
      toast.success(t("contracts.templateSavedSuccessfully"));
      setShowPrompt(false);
      exitForm();
    } catch (e) {
      toast.error(e.message);
      setSaveContractTemplateModal(false);
    } finally {
      setPdfLoader(false);
    }
  };
  return (
    <Fragment>
      {(isLoadingTemplate || pdfLoader) && <Loader />}

      {previewContract ? (
        designationType === 1 ? (
          <PreviewPersonnelContract
            officeDetail={officeDetail}
            contractData={BasicDetails}
            contractFormDisplayData={contractFormDisplayData}
            isEdit={true}
          />
        ) : (
          <PreviewAssociateContract
            officeDetail={officeDetail}
            contractData={BasicDetails}
            contractFormDisplayData={contractFormDisplayData}
            isEdit={true}
          />
        )
      ) : (
        <div className="multi-step-form ">
          <ol className="steps-tracker">{renderSteps()}</ol>
          <div className="form-body">{renderForm(compState)}</div>
        </div>
      )}
      <div className="prev-next-buttons">{renderNav(showNav)}</div>

      {modalIsOpen && (
        <CancelContractModal
          isModalOpen={modalIsOpen}
          saveDraft={() => saveDraftContract(true)}
          closeModal={() => {
            setModalIsOpen(false);
          }}
          exitForm={exitForm}
        />
      )}
      {confirmSentModal && (
        <ConfirmContractModal
          isModalOpen={confirmSentModal}
          sendContract={() => sendContract()}
          closeModal={() => {
            setConfirmSentModal(false);
          }}
        />
      )}

      {saveContractTemplateModal && (
        <SaveTemplateModal
          isModalOpen={saveContractTemplateModal}
          saveContractTemplate={saveContractTemplate}
          closeModal={() => {
            exitForm();
          }}
        />
      )}
    </Fragment>
  );
}
export default withTranslation()(EditContract);
